import { render, staticRenderFns } from "./SidebarUser.vue?vue&type=template&id=3a630ed2&"
import script from "./SidebarUser.vue?vue&type=script&lang=js&"
export * from "./SidebarUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports